(() => {
  const isMobile = () => window.matchMedia("(max-width: 749px)").matches;

  const initTrendingCycle = (wrap) => {
    const input = wrap.querySelector('input[type="search"]');
    const label = wrap.querySelector('.field__label');
    if (!input || !label) return;

    const termsRaw = wrap.dataset.cxTrendingTerms || '';
    const prefix = wrap.dataset.cxTrendingPrefix || '';
    const intervalMs = parseInt(wrap.dataset.cxTrendingInterval || '2500', 10);

    const terms = termsRaw.split(',').map((t) => t.trim()).filter(Boolean);
    if (terms.length === 0) return;

    const baseLabel = label.textContent.trim();
    let idx = 0;
    let timer = null;
    let termEl = null;

    const renderTrending = (term) => {
      const prefixHTML = prefix
        ? `<span class="cx-trending-prefix">${prefix}</span> `
        : '';
      label.innerHTML = `${prefixHTML}<span class="cx-trending-term">${term}</span>`;
      termEl = label.querySelector('.cx-trending-term');
    };

    const setTerm = (term) => {
      if (!termEl) return;
      termEl.classList.add('cx-fading');
      setTimeout(() => {
        if (!termEl) return;
        termEl.textContent = term;
        termEl.classList.remove('cx-fading');
      }, 300);
    };

    const restoreBaseLabel = () => {
      label.textContent = baseLabel;
      termEl = null;
    };

    const cycle = () => {
      if (input.value.length > 0 || document.activeElement === input) return;
      idx = (idx + 1) % terms.length;
      setTerm(terms[idx]);
    };

    const start = () => {
      if (timer) return;
      if (!termEl) renderTrending(terms[idx]);
      timer = setInterval(cycle, intervalMs);
    };

    const stop = () => {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    };

    input.addEventListener('focus', () => {
      stop();
      restoreBaseLabel();
    });

    input.addEventListener('blur', () => {
      if (input.value.length === 0) start();
    });

    if (input.value.length === 0 && document.activeElement !== input) {
      start();
    }
  };

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll("[data-cx-collection-search]")
      .forEach((wrap) => {
        const form = wrap.querySelector("form.search");
        const input = wrap.querySelector('input[type="search"]');
        if (!form || !input) return;

        form.addEventListener("submit", (e) => {
          if (!isMobile()) return;
          e.preventDefault();
          input.focus();
        });

        input.addEventListener("keydown", (e) => {
          if (!isMobile()) return;
          if (e.key === "Enter") {
            e.preventDefault();
          }
        });

        initTrendingCycle(wrap);
      });
  });
})();
